import { render, staticRenderFns } from "./inputBox.vue?vue&type=template&id=6aa1cca1&scoped=true"
import script from "./inputBox.vue?vue&type=script&lang=js"
export * from "./inputBox.vue?vue&type=script&lang=js"
import style0 from "./inputBox.vue?vue&type=style&index=0&id=6aa1cca1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa1cca1",
  null
  
)

export default component.exports